import getUrlParamsToObject from '../url/getUrlParamsToObject';

/**
 * Init the change of form elements based on URL params
 */
export default function initFormDynamicContent() {
	const urlParams = getUrlParamsToObject();

	const mapping = {
		title: function(text) {
			const $pageTitle = document.querySelector('[data-theme-template="title"]');
			document.title = text;

			if (!$pageTitle) {
				return;
			}

			$pageTitle.innerText = text;
		},
		subtitle: function(text) {
			const $pageSubtitle = document.querySelector('[data-theme-template="subtitle"]');

			if (!$pageSubtitle) {
				return;
			}

			$pageSubtitle.innerText = text;
		},
		formtitle: function(text) {
			const $formTitle = document.querySelector('[data-theme-template="formtitle"]');

			if (!$formTitle) {
				return;
			}

			$formTitle.innerText = text;
		},
		companyname: function(text) {
			const $companyName = document.getElementById('company-name'),
				extraText = window?.siteConfig?.service?.toLowerCase() === 'hvac' ? '' : ' from';

			if (!$companyName) {
				return;
			}

			text = text.slice(0, 1).toUpperCase() + text.slice(1); // Capitalizes Company Name
			$companyName.innerText = extraText + ' ' + text;
		},
		dt: function(dt) {
			const $dynamicText = document.getElementsByClassName('dynamic-text'),
				dynamicTextArray = dt.split('|');
			let newText;

			for (let i = 0; i < dynamicTextArray.length; i++) {
				newText = dynamicTextArray[i];

				if (newText && $dynamicText[i]) {
					$dynamicText[i].innerText = newText;
				}
			}
		},
		vp: function(vp) {
			const $valueProps = document.querySelectorAll('[data-theme-template="vp"]'),
				valuePropsArray = vp.split('|');
			let newText;

			for (let i = 0; i < valuePropsArray.length; i++) {
				newText = valuePropsArray[i];

				if (newText && $valueProps[i]) {
					$valueProps[i].innerText = newText;
				}
			}
		}
	};

	Object.keys(mapping).forEach((key) => {
		if ('string' === typeof urlParams[key] && urlParams[key] !== '') {
			mapping[key](urlParams[key]);
		}
	});
}

document.addEventListener('DOMContentLoaded', function() {
	initFormDynamicContent();
}, { once: true });
